import { Col, Row } from 'react-bootstrap';
import { BCFieldsDto } from '../../../types';

interface Props {
  bcTypeForm: BCFieldsDto;
  setBCTypeForm: any;
}
function BCReferenceForm({ bcTypeForm, setBCTypeForm }: Props) {
  return (
    // <div className=''>
    //   <div className=' p-4'>
    <Row className='align-items-center'>
      <Col lg={5}>
        <label className='lex-main-18-400 my-auto' htmlFor='bc_reference_one'>
          Customer Ref One (50 chars)
        </label>
        <input
          id='bc_reference_one'
          className='form-control ubbe-input'
          maxLength={50}
          autoComplete='new-password'
          placeholder='Reference'
          value={bcTypeForm.bc_customer_reference_one}
          onChange={(e) => {
            setBCTypeForm({
              ...bcTypeForm,
              bc_customer_reference_one: e.target.value,
            });
          }}
        />
      </Col>
      <Col lg={5}>
        <label className='lex-main-18-400 my-auto' htmlFor='bc_reference_two'>
          Customer Ref Two (50 chars)
        </label>
        <input
          id='bc_reference_two'
          className='form-control ubbe-input'
          maxLength={50}
          autoComplete='new-password'
          placeholder='Reference'
          value={bcTypeForm.bc_customer_reference_two}
          onChange={(e) => {
            setBCTypeForm({
              ...bcTypeForm,
              bc_customer_reference_two: e.target.value,
            });
          }}
        />
      </Col>
      <Col lg={2}>
        <div className='form-check mt-4'>
          <input
            className='form-check-input'
            type='checkbox'
            id='is_code_99'
            checked={bcTypeForm.bc_customer_reference_three === 'Code 99'}
            onChange={(e) => {
              setBCTypeForm({
                ...bcTypeForm,
                bc_customer_reference_three: e.target.checked
                  ? 'Code 99'
                  : 'Regular',
              });
            }}
          />
          <label className='form-check-label lex-16-300' htmlFor='is_code_99'>
            Is this Code 99?
          </label>
        </div>
      </Col>
    </Row>
    //   </div>
    // </div>
  );
}

export default BCReferenceForm;
